import { toast } from "App";
import { $api } from "./interceptor";
import { AxiosError } from "axios";
import { adminsStore } from "views/store/useAdminsStore";
import { Admin } from "types/admin";

const AdminsService = () => {
  const createAdmin = async (email: string, password: string) => {
    const requestData = {
      email,
      password,
    };
    try {
      adminsStore.setState({ isAdminsLoading: true });
      await $api.post("api/admins", requestData);
    } catch (e) {
      console.log('error create admin', e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Error creating new admin",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    } finally {
      adminsStore.setState({ isAdminsLoading: true });
    }
  };

  const getAdminsList = async () => {
    try {
        adminsStore.setState({ isAdminsLoading: true });
        const admins = await $api.get<Admin[]>('api/admins');
        adminsStore.setState({ admins: admins.data });
      } catch (e) {
        console.log('error fetch admins', e);
        if (e instanceof AxiosError) {
          toast({
            title: "Error",
            description: e.response?.data.message,
            status: "error",
            position: "top-right",
          });
        } 
        throw e;
      } finally {
        adminsStore.setState({ isAdminsLoading: true });
      }
  };

  const deleteAdmin = async (adminId: string) => {
    try {
        adminsStore.setState({ isAdminsLoading: true });
        await $api.delete(`api/admins/${adminId}`);
      } catch (e) {
        console.log('error delete admin', e);
        if (e instanceof AxiosError) {
          toast({
            title: "Error",
            description: e.response?.data.message,
            status: "error",
            position: "top-right",
          });
        } 
        throw e;
      } finally {
        adminsStore.setState({ isAdminsLoading: true });
      }
  };

  return {
    createAdmin,
    getAdminsList,
    deleteAdmin,
  };
};

export const adminsService = AdminsService();
